/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  // open swatches
  document.addEventListener('DOMContentLoaded', () => {
    const btnOpenSwatch = document.querySelector('.swatch__more.opened');
    if(btnOpenSwatch) btnOpenSwatch.click();
  });

// Ovillo progress bar
  function updateOvilloPosition() {
    const progressBar = document.querySelector('[data-cart-message-progress]');
    const holder = document.querySelector('.cart-message__progress-holder');
    if (progressBar && holder) {
      const percent = progressBar.getAttribute('value') || 0;
      holder.style.setProperty('--progress-width', percent + '%');
    }
  }

  const cartObserver = new MutationObserver(updateOvilloPosition);
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  if (cartDrawer) {
    cartObserver.observe(cartDrawer, { subtree: true, attributes: true, attributeFilter: ['value'] });
  }

  document.addEventListener('DOMContentLoaded', updateOvilloPosition);

  // Fix: redondear porcentaje de descuento al entero más cercano (en vez de floor)
  const _originalFloor = Math.floor;
  Math.floor = function(x) {
    const stack = new Error().stack || '';
    if (stack.includes('priceOffAmount') || (x > 0 && x < 100 && Math.abs(x - Math.round(x)) < 0.6)) {
      return Math.round(x);
    }
    return _originalFloor(x);
  };

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();